import React, { Suspense, useEffect, useState } from 'react';
import { Switch, Route, useHistory, Redirect } from 'react-router-dom';

//import PropList from 'pages/Proposal/PropList';
import { Spin } from 'antd';
import TasksList from 'pages/Tasks/TasksList';
import { AuthContext } from 'components/Auth/Auth';
import { useTranslation } from 'react-i18next';
import EntityFollowup from 'pages/workflow/EntityFollowUp/EntityFollowUpList';
import PFileDetail from 'pages/Payment/PFileDetail';
import PFileINExtract from 'pages/Payment/PFileINExtract';
import CreateSInvoiceFileService from 'pages/SupplierInvoice/CreateSInvoiceFileService';
import PFileOUTExtract from 'pages/Payment/PFileOUTExtract';
import PFileIMPORT from 'pages/Payment/PFileIMPORT';
import StatisticsProdList from 'pages/Statistic/StatisticProductionList';
import ProcTaskConseqList from 'pages/workflow/Kafka/ProcTaskConseqList';
import ScheduleTopicNotInvoicedList from 'pages/workflow/Kafka/ScheduleTopicNotInvoicedList';
import RunCollection from 'pages/Collection/RunCollection';
import SIFileDetail from 'pages/SupplierInvoice/SIFileDetail';
import ScoringDetailV2 from 'pages/Scoring/ScoringDetail/ScoringDetailV2';
import AutoPayNetting from 'pages/Payment/AutoPayNetting';
import PayListRepresentement from 'pages/Payment/PayRepresentment';
import SuperSetDocker from 'pages/superset/SuperSetDocker';
import FinContractEndOfTermReq from 'pages/ProposalV3/FinContractEndOfTermReq';
import SimpleQuickSimulation from 'pages/PosPhonesShop/SimpleQuickSimul';
import AssetListToConvert from 'pages/PosPhonesShop/AssetListToConvert';
import MyRequests from 'pages/PosPhonesShop/MyRequests';
import UsedCarFin from 'pages/PosPhonesShop/UsedCarFin';
import DealerContracts from 'pages/PosPhonesShop/DealerContracts';
import DealerPayment from 'pages/PosPhonesShop/DealerPayment';
import NewCarFin from 'pages/PosPhonesShop/NewCarFin';
import ExtendLongTermRental from 'pages/ProposalV3/ExtendLongTermRental';
import ThirdPartyDetailSFS from 'pages/ThirdParty/ThirdPartySFS/ThirdPartyDetailSFS/ThirdPartyDetailSFS';
import ThirdPartyListSFS from 'pages/ThirdParty/ThirdPartySFS/ThirdPartyListSFS';
import Notauthorized from 'pages/404/notauthorized';

export type PrivateRouteProps = any;

export const PrivateRoute = (props: PrivateRouteProps) => {
  const history = useHistory();
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    setToken(localStorage.getItem('token'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem('token')]);

  if (!token) {
    localStorage.setItem('token', '');
    history.push('/login');
    return null;
  }

  return <Route {...props} />;
};
const PurchaseOrderList = React.lazy(
  () => import('pages/Purchase/PurchaseOrderList')
);
const TaskGolablEventModal = React.lazy(
  () => import('pages/workflow/TaskGolablEventModal')
);

const MyCatalog = React.lazy(() => import('pages/PosPhonesShop/myCatalog'));

const SiSasList = React.lazy(() => import('pages/SupplierInvoice/SiSasList'));
const SIfilesList = React.lazy(
  () => import('pages/SupplierInvoice/SIFileList')
);

const ThirdPartyDetail = React.lazy(
  () => import('pages/ThirdParty/ThirdPartyDetail')
);
const CollectionDetail = React.lazy(
  () => import('pages/Collection/CollectionDetail/CollectionDetail')
);
const CollectionList = React.lazy(
  () => import('pages/Collection/CollectionList')
);
const GuarantDetail = React.lazy(
  () => import('pages/guaranty/guarantyDetails')
);
const SuperSet = React.lazy(() => import('pages/superset/SuperSet'));
const Guaranty = React.lazy(() => import('pages/guaranty/guaranty'));
const Landing = React.lazy(() => import('pages/Landing/Landing'));
const TpList = React.lazy(() => import('pages/ThirdParty/TpList'));
const PrintingList = React.lazy(
  () => import('pages/Print/PrintingList/PrintingList')
);
const StatisticJobService = React.lazy(
  () => import('pages/Statistic/StatisticJob')
);
const SIList = React.lazy(() => import('pages/SupplierInvoice/SlList'));

const SIDetail = React.lazy(
  () => import('pages/SupplierInvoice/SIDetail/index')
);
const ServicesFollowup = React.lazy(
  () => import('pages/Services/ServicesFollowup')
);
const ScoringList = React.lazy(() => import('pages/Scoring/ScoringList'));
const ScoringGridList = React.lazy(
  () => import('pages/Scoring/ScoringGridList')
);
const ScoringGridDetails = React.lazy(
  () => import('pages/Scoring/ScoringGrid/ScoringGridDetails')
);
const ScoringDetail = React.lazy(
  () => import('pages/Scoring/ScoringDetail/ScoringDetailV2')
);
const PurchaseOrderDetail = React.lazy(
  () => import('pages/Purchase/PurchaseOrderDetail')
);
const PropListV3 = React.lazy(() => import('pages/ProposalV3/PropList'));
const PropDetailV3 = React.lazy(() => import('pages/ProposalV3/PropDetail'));
const Portfolio = React.lazy(() => import('pages/PosPhonesShop/portfolio'));
const BrokerContracts = React.lazy(
  () => import('pages/PosPhonesShop/Contracts')
);
const Catalog = React.lazy(() => import('pages/PosPhonesShop/catalog'));
const MyBrokerProfile = React.lazy(
  () => import('pages/Configuration/ManagementCompany/BrokerDetail/index')
);

const PAYNettingList = React.lazy(
  () => import('pages/Payment/PAYNetting/NettingList')
);
const PAYNet = React.lazy(() => import('pages/Payment/PAYNet'));
const PayList = React.lazy(() => import('pages/Payment/PAYList'));
const Lead = React.lazy(() => import('pages/Lead/Lead'));
const FlowEditor = React.lazy(() => import('pages/FlowEditor/FlowEditor'));
const AccountingConfiguration = React.lazy(() => import('pages/Accounting'));
const AssetDetail = React.lazy(() => import('pages/Asset/AssetDetail'));
const AssetList = React.lazy(() => import('pages/Asset/AssetList'));
const AttributeDetail = React.lazy(
  () => import('pages/Attribute/AttributeDetail')
);
const AttributeList = React.lazy(() => import('pages/Attribute/AttributeList'));
const ChangePassword = React.lazy(
  () => import('pages/ChangePassword/ChangePassword')
);
const CIDetail = React.lazy(() => import('pages/ClientInvoice/CIDetail'));
const CIList = React.lazy(() => import('pages/ClientInvoice/CIList'));
const CIPrintingService = React.lazy(
  () => import('pages/ClientInvoice/CIPrintingService')
);
const ConfigurationRoutes = React.lazy(() => import('pages/Configuration'));
const DocList = React.lazy(() => import('pages/Document/DocList'));
const Pay = React.lazy(() => import('pages/Payment/PAYDetail/index'));
const EvollisInvoicingService = React.lazy(
  () => import('pages/ClientInvoice/EvollisInvoicingService')
);

const GenPaymentINService = React.lazy(
  () => import('pages/Payment/PayINService')
);
const PFileINService = React.lazy(() => import('pages/Payment/PFileINService'));
const PFileList = React.lazy(() => import('pages/Payment/PFileList'));
const GenPaymentOUTService = React.lazy(
  () => import('pages/Payment/PayOUTService/index')
);
const PFileOUTService = React.lazy(
  () => import('pages/Payment/PFileOUTService/index')
);
const InvoicingService = React.lazy(
  () => import('pages/ClientInvoice/InvoicingService')
);
const LateChargeService = React.lazy(
  () => import('pages/ClientInvoice/LateChargeService')
);
const LateChargeInvoicingService = React.lazy(
  () => import('pages/ClientInvoice/LateChargeInvoicingService')
);
const EvollisExecContractOperation = React.lazy(
  () => import('pages/Contract/EvollisExecContractOperation')
);
const FinModification = React.lazy(() => import('pages/FinModification'));

const Routes: React.FC = () => {
  const [usertype] = useState(() => localStorage.getItem('usertype'));
  const [userrole] = useState(() => localStorage.getItem('userrole'));
  // eslint-disable-next-line no-unused-vars
  const { t } = useTranslation();

  return (
    <AuthContext.Consumer>
      {(context) => (
        <Suspense
          fallback={
            <Spin
              size="large"
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          }
        >
          {usertype === 'INTERNAL' ? (
            <Switch>
              <PrivateRoute
                path={['/third-party/create', '/third-party/:id/:phase']}
                component={ThirdPartyDetail}
              />
              <PrivateRoute path="/third-party" component={TpList} />
              <PrivateRoute
                path="/thirdparty-sfs"
                component={ThirdPartyListSFS}
                exact
              />
              <PrivateRoute
                path={['/thirdparty-sfs/create', '/thirdparty-sfs/:id/:phase']}
                component={ThirdPartyDetailSFS}
                exact
              />
              <PrivateRoute
                path={['/proposal/create', '/proposal/:id']}
                component={PropDetailV3}
              />

              <PrivateRoute path="/proposal" component={PropListV3} />

              <PrivateRoute path="/asset/:id/PROD">
                <AssetDetail phaseprop="PROD" />
              </PrivateRoute>

              <PrivateRoute
                path={['/asset/create/PROPOSAL', '/asset/:id/PROPOSAL']}
              >
                <AssetDetail phaseprop="PROPOSAL" />
              </PrivateRoute>
              <PrivateRoute path="/asset">
                <AssetList />
              </PrivateRoute>
              <PrivateRoute
                path={['/supplier-invoice/:id']}
                component={SIDetail}
              ></PrivateRoute>
              <PrivateRoute path="/supplier-invoice-saas">
                <SiSasList />
              </PrivateRoute>

              <PrivateRoute path="/supplier-invoice">
                <SIList />
              </PrivateRoute>

              <PrivateRoute path={['/supplier-invoice-file/:sfid']}>
                <SIFileDetail />
              </PrivateRoute>

              <PrivateRoute path="/supplier-invoice-file">
                <SIfilesList />
              </PrivateRoute>

              <PrivateRoute
                path="/services/followup"
                component={ServicesFollowup}
              />
              <PrivateRoute
                path="/supplier-invoicing/run/createSIFile"
                component={CreateSInvoiceFileService}
              />
              <PrivateRoute
                path={['/client-invoice/:idOrCreate']}
                component={CIDetail}
              />

              <PrivateRoute path="/client-invoice" component={CIList} />
              <PrivateRoute
                path="/client-invoicing/run/evollis"
                component={EvollisInvoicingService}
              />
              <PrivateRoute
                path="/client-invoicing/run/scheduledPayment"
                component={InvoicingService}
              />

              <PrivateRoute
                path="/client-invoicing/run/lateCharge"
                component={LateChargeService}
              />

              <PrivateRoute
                path="/client-invoicing/run/lateChargeInvoicing"
                component={LateChargeInvoicingService}
              />
              <PrivateRoute
                path="/payment/run/genPaymentIN"
                component={GenPaymentINService}
              />

              <PrivateRoute
                path="/payment/run/autoPayNetting"
                component={AutoPayNetting}
              />

              <PrivateRoute
                path="/payment/run/createPaymentFileIN"
                component={PFileINService}
              />

              <PrivateRoute
                path="/payment/run/extractPaymentFileIN"
                component={PFileINExtract}
              />

              <PrivateRoute
                path="/payment/run/extractPaymentFileOUT"
                component={PFileOUTExtract}
              />

              <PrivateRoute
                path="/payment/run/genPaymentOUT"
                component={GenPaymentOUTService}
              />

              <PrivateRoute
                path="/payment/run/createPaymentFileOUT"
                component={PFileOUTService}
              />

              <PrivateRoute
                path="/contract/run/evollis"
                component={EvollisExecContractOperation}
              />
              <PrivateRoute
                path="/contract/finModification"
                component={FinModification}
              />

              <PrivateRoute
                path="/client-invoicing/run/print"
                component={CIPrintingService}
              />

              <PrivateRoute
                path={['/payment/create', '/payment/:id']}
                component={Pay}
              ></PrivateRoute>

              {/* <PrivateRoute
      path={['/pay/create', '/pay/:id']}
      component={Pay}
    ></PrivateRoute> */}

              <PrivateRoute path={['/paynetting/create', '/paynetting/:payid']}>
                <PAYNet />
              </PrivateRoute>

              <PrivateRoute path="/paynetting">
                <PAYNettingList />
              </PrivateRoute>
              <PrivateRoute path="/paynetting/paynet">
                <PAYNet />
              </PrivateRoute>
              <PrivateRoute path="/payment">
                <PayList />
              </PrivateRoute>
              <PrivateRoute path="/paymentfile">
                <PFileList paydirection="" />
              </PrivateRoute>

              <PrivateRoute path="/pfiledetail/:pfid">
                <PFileDetail />
              </PrivateRoute>
              <PrivateRoute path={['/scoring/create', '/scoring/:id']}>
                <ScoringDetailV2 />
              </PrivateRoute>
              <PrivateRoute path="/scoring">
                <ScoringList />
              </PrivateRoute>
              {userrole === 'ADMIN' && (
                <PrivateRoute
                  path={[
                    '/parscoring/grid/create',
                    '/parscoring/grid/:id',
                    '/parscoring/grid/:id/:duplicate',
                  ]}
                  exact
                >
                  <ScoringGridDetails />
                </PrivateRoute>)}
              {userrole === 'ADMIN' && (
                <PrivateRoute
                  path="/parscoring/grid"
                  component={ScoringGridList}
                />)}
              <PrivateRoute
                path={['/purchase-order/:idOrCreate']}
                component={PurchaseOrderDetail}
              />
              <PrivateRoute
                path="/purchase-order"
                component={PurchaseOrderList}
              />
              <PrivateRoute path="/document">
                <DocList categorie="DOC" />
              </PrivateRoute>
              <PrivateRoute
                path={['/catalog', '/catalog/create', '/catalog/:id']}
                exact
              >
                <Catalog />
              </PrivateRoute>

              <PrivateRoute path={['/newCarFinancing']} exact>
                <NewCarFin />
              </PrivateRoute>

              <PrivateRoute path={['/catalog/contract/:id/PROD']} exact>
                <SimpleQuickSimulation />
              </PrivateRoute>

              <PrivateRoute path={['/mycatalog']} exact>
                <MyCatalog />
              </PrivateRoute>
              <PrivateRoute path="/myportfolio">
                <Portfolio />
              </PrivateRoute>
              <PrivateRoute path="/mycontract">
                <BrokerContracts />
              </PrivateRoute>

              <PrivateRoute path="/dealercontract/:status" exact>
                <DealerContracts />
              </PrivateRoute>
              <PrivateRoute path="/dealerpayment" exact>
                <DealerPayment />
              </PrivateRoute>
              <PrivateRoute path="/partner/myProfile">
                <MyBrokerProfile />
              </PrivateRoute>


              {userrole === 'ADMIN' && (
                <PrivateRoute
                  path={[
                    '/parscoring/attribute/create',
                    '/parscoring/attribute/:idfromUrl/:duplicate',
                    '/parscoring/attribute/:idfromUrl',
                  ]}
                >
                  <AttributeDetail />
                </PrivateRoute>)}
              {userrole === 'ADMIN' && (
                <PrivateRoute
                  path="/parscoring/attribute"
                  component={AttributeList}
                />)}
              <PrivateRoute path="/flow-editor" component={FlowEditor} />
              <Route
                path="/statistics/run/production"
                exact
                component={StatisticJobService}
              />

              <Route
                path="/statistics/production"
                exact
                component={StatisticsProdList}
              />

              <PrivateRoute
                path="/accounting"
                component={AccountingConfiguration}
              />
              {userrole === 'ADMIN' && (
                <PrivateRoute
                  path="/configuration"
                  component={ConfigurationRoutes}
                />
              )}

              <PrivateRoute
                path="/change-password"
                component={ChangePassword}
              />

              <PrivateRoute
                path="/paymentrepresentement"
                component={PayListRepresentement}
              />

              <PrivateRoute path="/pfileimport" component={PFileIMPORT} />

              <PrivateRoute path={['/lead/create', '/lead/:id']}>
                <Lead />
              </PrivateRoute>
              <PrivateRoute exact path={['/', '/welcome']}>
                <Landing />
              </PrivateRoute>

              <PrivateRoute exact path="/partner/myProfile">
                <MyBrokerProfile />
              </PrivateRoute>

              <PrivateRoute exact path={['/landing']}>
                <Landing />
              </PrivateRoute>
              <PrivateRoute exact path={['/guaranty']}>
                <Guaranty />
              </PrivateRoute>
              <PrivateRoute
                path="/guaranty/:idOrCreate"
                component={GuarantDetail}
              />
              <PrivateRoute path="/superset/:id" component={SuperSet} />
              <PrivateRoute
                path="/supersetdocker/:id"
                component={SuperSetDocker}
              />

              <PrivateRoute exact path={['/collection']}>
                <CollectionList />
              </PrivateRoute>
              <PrivateRoute exact path={['/collection/run']}>
                <RunCollection />
              </PrivateRoute>
              <PrivateRoute
                path={['/collection/:id']}
                component={CollectionDetail}
              ></PrivateRoute>
              <PrivateRoute exact path={['/event/global']}>
                <TaskGolablEventModal />
              </PrivateRoute>

              <PrivateRoute exact path={['/tasks']}>
                <TasksList />
              </PrivateRoute>

              <PrivateRoute exact path={['/workflow/entityfollowup']}>
                <EntityFollowup />
              </PrivateRoute>

              <PrivateRoute
                exact
                path={['/workflow/KafkaTopic/ScheduleTopicNotInvoiced']}
              >
                <ScheduleTopicNotInvoicedList />
              </PrivateRoute>
              <PrivateRoute exact path={['/workflow/Kafka/proctaskconseqlist']}>
                <ProcTaskConseqList />
              </PrivateRoute>
              <PrivateRoute path="/printinglist" component={PrintingList} />

              <PrivateRoute
                path="/fin-contract/run/endoftermreq"
                component={FinContractEndOfTermReq}
              />
              <PrivateRoute
                path="/fin-contract/run/extendlongtermrental"
                component={ExtendLongTermRental}
              />
              <PrivateRoute path="/403" component={Notauthorized} />
              <Route path="*">
                <Redirect
                  to={{
                    pathname: '/pageNotFound',
                  }}
                />
              </Route>
            </Switch>
          ) : (
            <Switch>
              {context.menu.find((item: any) =>
                item.pagurl.includes('/third-party')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/third-party/create', '/third-party/:id/:phase']}
                    component={ThirdPartyDetail}
                  />
                )}

              {context.menu.find(
                (item: any) => item.pagurl === '/third-party'
              ) !== undefined && (
                  <PrivateRoute path="/third-party" component={TpList} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/proposal')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/proposal/create', '/proposal/:id']}
                    component={PropDetailV3}
                  />
                )}

              {context.menu.find((item: any) => item.pagurl === '/proposal') !==
                undefined && (
                  <PrivateRoute path="/proposal" component={PropListV3} />
                )}

              <PrivateRoute
                path="/fin-contract/run/endoftermreq"
                component={FinContractEndOfTermReq}
              />
              {context.menu.find((item: any) =>
                item.pagurl.includes('/asset')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/asset/create/PROPOSAL', '/asset/:id/PROPOSAL']}
                  >
                    <AssetDetail phaseprop="PROPOSAL" />
                  </PrivateRoute>
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/asset')
              ) !== undefined && (
                  <PrivateRoute path="/asset/:id/PROD">
                    <AssetDetail phaseprop="PROD" />
                  </PrivateRoute>
                )}

              {context.menu.find((item: any) => item.pagurl === '/asset') !==
                undefined && (
                  <PrivateRoute path="/asset">
                    <AssetList />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/supplier-invoice')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/supplier-invoice/:id']}
                    component={SIDetail}
                  ></PrivateRoute>
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/supplier-invoice-sas'
              ) !== undefined && (
                  <PrivateRoute path="/supplier-invoice-saas">
                    <SiSasList />
                  </PrivateRoute>
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/supplier-invoice'
              ) !== undefined && (
                  <PrivateRoute path="/supplier-invoice">
                    <SIList />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/client-invoice')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/client-invoice/:idOrCreate']}
                    component={CIDetail}
                  />
                )}

              {context.menu.find(
                (item: any) => item.pagurl === '/client-invoice'
              ) !== undefined && (
                  <PrivateRoute path="/client-invoice" component={CIList} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/client-invoicing')
              ) !== undefined && (
                  <PrivateRoute
                    path="/client-invoicing/run/evollis"
                    component={EvollisInvoicingService}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/client-invoicing')
              ) !== undefined && (
                  <PrivateRoute
                    path="/client-invoicing/run/scheduledPayment"
                    component={InvoicingService}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/client-invoicing')
              ) !== undefined && (
                  <PrivateRoute
                    path="/client-invoicing/run/lateCharge"
                    component={LateChargeService}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/client-invoicing')
              ) !== undefined && (
                  <PrivateRoute
                    path="/client-invoicing/run/lateChargeInvoicing"
                    component={LateChargeInvoicingService}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/contract')
              ) !== undefined && (
                  <PrivateRoute
                    path="/contract/run/evollis"
                    component={EvollisExecContractOperation}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/contract')
              ) !== undefined && (
                  <PrivateRoute
                    path="/contract/finModification"
                    component={FinModification}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/services')
              ) !== undefined && (
                  <PrivateRoute
                    path="/services/followup"
                    component={ServicesFollowup}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/client-invoicing')
              ) !== undefined && (
                  <PrivateRoute
                    path="/client-invoicing/run/print"
                    component={CIPrintingService}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/payment')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/payment/create', '/payment/:id']}
                    component={Pay}
                  ></PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/paynetting')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/paynetting/create', '/paynetting/:payid']}
                  >
                    <PAYNet />
                  </PrivateRoute>
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/paynetting'
              ) !== undefined && (
                  <PrivateRoute path="/paynetting">
                    <PAYNettingList />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/paynetting')
              ) !== undefined && (
                  <PrivateRoute path="/paynetting/paynet">
                    <PAYNet />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) => item.pagurl === '/payment') !==
                undefined && (
                  <PrivateRoute path="/payment">
                    <PayList />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/scoring')
              ) !== undefined && (
                  <PrivateRoute path={['/scoring/create', '/scoring/:id']}>
                    <ScoringDetail />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) => item.pagurl === '/scoring') !==
                undefined && (
                  <PrivateRoute path="/scoring">
                    <ScoringList />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <PrivateRoute
                    path={[
                      '/parscoring/grid/create',
                      '/parscoring/grid/:id',
                      '/parscoring/grid/:id/:duplicate',
                    ]}
                    exact
                  >
                    <ScoringGridDetails />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <PrivateRoute
                    path="/parscoring/grid"
                    component={ScoringGridList}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/purchase-order')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/purchase-order/:idOrCreate']}
                    component={PurchaseOrderDetail}
                  />
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/purchase-order'
              ) !== undefined && (
                  <PrivateRoute
                    path="/purchase-order"
                    component={PurchaseOrderList}
                  />
                )}
              {context.menu.find((item: any) => item.pagurl === '/document') !==
                undefined && (
                  <PrivateRoute path="/document">
                    <DocList categorie="DOC" />
                  </PrivateRoute>
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/catalog')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/catalog', '/catalog/create', '/catalog/:id']}
                    exact
                  >
                    <Catalog />
                  </PrivateRoute>
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/newCarFinancing')
              ) !== undefined && (
                  <PrivateRoute path={['/newCarFinancing']} exact>
                    <NewCarFin />
                  </PrivateRoute>
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/conversionFamily')
              ) !== undefined && (
                  <PrivateRoute path={['/conversionFamily']} exact>
                    <AssetListToConvert />
                  </PrivateRoute>
                )}

              <PrivateRoute
                path={[
                  '/assetListToConvert',
                  'assetListToConvert',
                  'assetListToConvert',
                ]}
                exact
              >
                <AssetListToConvert />
              </PrivateRoute>

              {context.menu.find((item: any) =>
                item.pagurl.includes('/conversionFamily')
              ) !== undefined && (
                  <PrivateRoute path={['/conversionFamily']} exact>
                    <AssetListToConvert />
                  </PrivateRoute>
                )}

              <PrivateRoute path={['/myRequests']} exact>
                <MyRequests />
              </PrivateRoute>

              <PrivateRoute path={['/usedCarFinancing']} exact>
                <UsedCarFin />
              </PrivateRoute>

              {context.menu.find((item: any) =>
                item.pagurl.includes('/catalog')
              ) !== undefined && (
                  <PrivateRoute path={['/mycatalog']} exact>
                    <MyCatalog />
                  </PrivateRoute>
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/myportfolio'
              ) !== undefined && (
                  <PrivateRoute path="/myportfolio">
                    <Portfolio />
                  </PrivateRoute>
                )}
              <PrivateRoute path="/dealercontract/:status" exact>
                <DealerContracts />
              </PrivateRoute>
              <PrivateRoute path="/dealerpayment" exact>
                <DealerPayment />
              </PrivateRoute>

              {context.menu.find(
                (item: any) => item.pagurl === '/partner/myProfile'
              ) !== undefined && (
                  <PrivateRoute path="/partner/myProfile">
                    <MyBrokerProfile />
                  </PrivateRoute>
                )}

              {context.menu.find(
                (item: any) => item.pagurl === '/mycontract'
              ) !== undefined && (
                  <PrivateRoute path="/mycontract">
                    <BrokerContracts />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <PrivateRoute
                    path={[
                      '/parscoring/attribute/create',
                      '/parscoring/attribute/:idfromUrl/:duplicate',
                      '/parscoring/attribute/:idfromUrl',
                    ]}
                  >
                    <AttributeDetail />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/parscoring')
              ) !== undefined && (
                  <PrivateRoute
                    path="/parscoring/attribute"
                    component={AttributeList}
                  />
                )}

              {context.menu.find(
                (item: any) => item.pagurl === '/flow-editor'
              ) !== undefined && (
                  <PrivateRoute path="/flow-editor" component={FlowEditor} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/statistics')
              ) !== undefined && (
                  <Route
                    path="/statistics/run/production"
                    exact
                    component={StatisticJobService}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/statistics')
              ) !== undefined && (
                  <Route
                    path="/statistics/production"
                    exact
                    component={StatisticsProdList}
                  />
                )}

              {context.menu.find((item: any) =>
                item.pagurl.includes('/accounting')
              ) !== undefined && (
                  <PrivateRoute
                    path="/accounting"
                    component={AccountingConfiguration}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/configuration')
              ) !== undefined ||
                (context.menu.find((item: any) =>
                  item.pagurl.includes('/mycatalog')
                ) !== undefined && (
                    <PrivateRoute
                      path="/configuration"
                      component={ConfigurationRoutes}
                    />
                  ))}

              <PrivateRoute
                path="/change-password"
                component={ChangePassword}
              />

              {context.menu.find((item: any) =>
                item.pagurl.includes('/lead')
              ) !== undefined && (
                  <PrivateRoute path={['/lead/create', '/lead/:id']}>
                    <Lead />
                  </PrivateRoute>
                )}

              <PrivateRoute exact path={['/', '/welcome']}>
                <Landing />
              </PrivateRoute>

              {context.menu.find((item: any) => item.pagurl === '/landing') !==
                undefined && (
                  <PrivateRoute exact path={['/landing']}>
                    <Landing />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) => item.pagurl === '/guaranty') !==
                undefined && (
                  <PrivateRoute exact path={['/guaranty']}>
                    <Guaranty />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/guaranty')
              ) !== undefined && (
                  <PrivateRoute
                    path="/guaranty/:idOrCreate"
                    component={GuarantDetail}
                  />
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/superset')
              ) !== undefined && (
                  <PrivateRoute path="/superset/:id" component={SuperSet} />
                )}
              {context.menu.find(
                (item: any) => item.pagurl === '/collection'
              ) !== undefined && (
                  <PrivateRoute exact path={['/collection']}>
                    <CollectionList />
                  </PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl.includes('/collection')
              ) !== undefined && (
                  <PrivateRoute
                    path={['/collection/:id']}
                    component={CollectionDetail}
                  ></PrivateRoute>
                )}
              {context.menu.find((item: any) =>
                item.pagurl?.includes('/printinglist')
              ) !== undefined && (
                  <PrivateRoute path="/printinglist" component={PrintingList} />
                )}

              {context.menu.find((item: any) =>
                item.pagurl?.includes('/tasks')
              ) !== undefined && (
                  <PrivateRoute exact path={['/tasks']}>
                    <TasksList />
                  </PrivateRoute>
                )}

              <PrivateRoute exact path={['/workflow/entityfollowup']}>
                <EntityFollowup />
              </PrivateRoute>

              <PrivateRoute
                exact
                path={['/workflow/KafkaTopic/ScheduleTopicNotInvoiced']}
              >
                <ScheduleTopicNotInvoicedList />
              </PrivateRoute>
              <PrivateRoute exact path={['/workflow/Kafka/proctaskconseqlist']}>
                <ProcTaskConseqList />
              </PrivateRoute>

              <Route path="*">
                <Redirect
                  to={{
                    pathname: '/pageNotFound',
                  }}
                />
              </Route>
            </Switch>
          )}
        </Suspense>
      )}
    </AuthContext.Consumer>
  );
};

export default Routes;
